import { Button } from '@/components/Button/Button';

import Dropdown from '@/components/Form/Dropdown';
import OnboardingWrapper from '@/components/Onboarding/OnboardingWrapper';

const workOptions = [
  { label: 'Researcher', value: 'researcher' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Educator', value: 'educator' },
  { label: 'Lawyer', value: 'lawyer' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Finance', value: 'finance' },
  { label: 'Operations', value: 'operations' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Student', value: 'student' },
  { label: 'Design', value: 'design' },
  { label: 'Other', value: 'other' },
];

const roleOptions = [
  { label: 'Executive (C-level / VP)', value: 'executive' },
  { label: 'Department lead', value: 'department_lead' },
  { label: 'Team manager', value: 'team_manager' },
  { label: 'Team member', value: 'team_member' },
  { label: 'Solo / Freelancer', value: 'solo' },
  { label: 'Using Anara just for myself', value: 'self' },
];

const companySizeOptions = [
  { label: '1-50', value: '1-50' },
  { label: '51-150', value: '51-150' },
  { label: '151-1000', value: '151-1000' },
  { label: '1001-10K', value: '1001-10k' },
  { label: '10K+', value: '10k+' },
];

const educationOptions = [
  { label: 'High-school', value: 'high_school' },
  { label: 'Undergraduate', value: 'undergraduate' },
  { label: 'Postgraduate', value: 'postgraduate' },
  { label: 'PhD & beyond', value: 'phd' },
];

const hearAboutUsOptions = [
  { label: 'Instagram', value: 'instagram' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'Reddit', value: 'reddit' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Google', value: 'google' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'X / Twitter', value: 'twitter' },
  { label: 'Friend', value: 'friend' },
  { label: 'AI', value: 'ai' },
  { label: 'Other', value: 'other' },
];

export interface OnboardingAnswers {
  purpose?: string;
  workType?: string;
  workRole?: string;
  companySize?: string;
  educationLevel?: string;
  hearAboutUs?: string;
}

const OnboardingQuestions = ({
  handleSelect,
  handleNextStep,
  purpose,
  disabled,
}: {
  purpose: 'work' | 'study' | 'personal' | null;
  handleSelect: (option: { value: string }, key: string) => void;
  handleNextStep: () => void;
  disabled: boolean;
}) => {
  switch (purpose) {
    case 'work':
      return (
        <OnboardingWrapper
          heading="Tell us about yourself"
          subHeading="This helps us customize your experience"
        >
          <div className="w-full flex flex-col mb-2 gap-1">
            <Dropdown
              options={workOptions}
              label="What kind of work do you do?"
              onSelect={(option: { value: string }) =>
                handleSelect(option, 'workType')
              }
            />
            <Dropdown
              options={roleOptions}
              label="What's your role?"
              onSelect={(option: { value: string }) =>
                handleSelect(option, 'workRole')
              }
            />
            <Dropdown
              options={companySizeOptions}
              label="How big is your company?"
              onSelect={(option: { value: string }) =>
                handleSelect(option, 'companySize')
              }
            />
            <Dropdown
              options={hearAboutUsOptions}
              label="Where did you hear about us?"
              onSelect={(option: { value: string }) =>
                handleSelect(option, 'hearAboutUs')
              }
            />
          </div>

          <Button
            onClick={handleNextStep}
            disabled={disabled}
            variant={disabled ? 'secondary' : 'default'}
            className="h-11 rounded-xl hover:scale-[1.02] ease-in transition-transform"
          >
            Continue
          </Button>
        </OnboardingWrapper>
      );
    case 'study':
      return (
        <OnboardingWrapper
          heading="Tell us about yourself"
          subHeading="This helps us customize your experience"
        >
          <div className="w-full flex flex-col mb-2 gap-1">
            <Dropdown
              options={educationOptions}
              label="What's your level of education?"
              // biome-ignore lint/suspicious/noExplicitAny: <explanation>
              onSelect={(option: any) => handleSelect(option, 'educationLevel')}
            />
            <Dropdown
              options={hearAboutUsOptions}
              label="Where did you hear about us?"
              // biome-ignore lint/suspicious/noExplicitAny: <explanation>
              onSelect={(option: any) => handleSelect(option, 'hearAboutUs')}
            />
          </div>

          <Button
            onClick={handleNextStep}
            disabled={disabled}
            variant={disabled ? 'secondary' : 'default'}
            className="h-11 rounded-xl hover:scale-[1.02] ease-in transition-transform"
          >
            Continue
          </Button>
        </OnboardingWrapper>
      );
    case 'personal':
      return (
        <OnboardingWrapper
          heading="Tell us about yourself"
          subHeading="This helps us customize your experience"
        >
          <div className="mb-2">
            <Dropdown
              options={hearAboutUsOptions}
              label="Where did you hear about us?"
              // biome-ignore lint/suspicious/noExplicitAny: <explanation>
              onSelect={(option: any) => handleSelect(option, 'hearAboutUs')}
            />
          </div>
          <Button
            onClick={handleNextStep}
            disabled={disabled}
            variant={disabled ? 'secondary' : 'default'}
            className="h-11 rounded-xl hover:scale-[1.02] ease-in transition-transform"
          >
            Continue
          </Button>
        </OnboardingWrapper>
      );
    default:
      return null;
  }
};

export default OnboardingQuestions;
